<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <img
        v-if="icon"
        :src="`/images/svg/${icon}.svg`"
        class="mr-2"
        height="24"
        aria-hidden="true"
        alt=""
      />
      <h3 class="section-title">{{ title }}</h3>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: undefined,
    },
  },
};
</script>
